module.exports = "/packs/step1_sp-76c1eb70cdfaabf55ddeb4cd9248269d.png";